import {Component, OnInit} from 'angular2/core';
import {CampaignService} from "../campaign.service";
import {Campaign} from "../../../models/campaign.model";
import {TranslatePipe, TranslateService} from "ng2-translate";
import {Router} from "angular2/router";
import {PaginatePipe, PaginationService} from 'ng2-pagination';
import {BootstrapPaginationComponent} from "../../common/pagination/bootstrap_pagination.component";
import {AlertService} from "../../common/alerts/alert.service";


@Component({
    templateUrl: './app/components/campaigns/index/list.html',
    directives: [BootstrapPaginationComponent],
    providers: [CampaignService, PaginationService],
    pipes: [TranslatePipe, PaginatePipe]
})
export class IndexCampaignsComponent implements OnInit {
    page:number;
    perPage:number;
    searchPattern:string;
    searchFilter:any = {expected: true, inprogress: true, soldout: true, finished: false};
    sortKey:string;
    reverse:boolean;
    total:number;
    campaigns:Campaign[];
    errorMessage:string;

    constructor(private _campaignService:CampaignService, private _alert_service:AlertService, private _router:Router,
                private _translateService:TranslateService) {
        this.page = 1;
        this.perPage = 10;
        this.searchPattern = "*";
        this.sortKey = "commercialId";
        this.reverse = true;
    }

    downloadCsvLink(id) {
        this._campaignService.getDownloadCsv(id).subscribe(void {});
    }

    ngOnInit() {
        this._campaignService.count(this.searchPattern, this.searchFilter).subscribe(count => this.total = count);
        this.getPage(this.page);
    }

    getPage(page:number) {
        this._campaignService.count(this.searchPattern, this.searchFilter).subscribe(count => this.total = count);
        this._campaignService.getCampaigns(page, this.perPage, this.sortKey, this.reverse, this.searchPattern, this.searchFilter)
        .subscribe(
            campaigns => {
                this.campaigns = campaigns;
                this.page = page;
            },
            error => this.errorMessage = <any>error
        );
    }
    getPattern(searchPattern:string) {
        this._campaignService.count(this.searchPattern, this.searchFilter).subscribe(count => this.total = count);
        this._campaignService.getCampaigns(this.page, this.perPage, this.sortKey, this.reverse, searchPattern, this.searchFilter)
        .subscribe(
            campaigns => {
                this.campaigns = campaigns;
            },
            error => this.errorMessage = <any>error
        );
    }

    getFilter(searchFilter:boolean) {
        this._campaignService.count(this.searchPattern, this.searchFilter).subscribe(count => this.total = count);
        this._campaignService.getCampaigns(this.page, this.perPage, this.sortKey, this.reverse, this.searchPattern, this.searchFilter)
        .subscribe(
            campaigns => {
                this.campaigns = campaigns;
            },
            error => this.errorMessage = <any>error
        );
    }

    getSort(sortKey:string) {
        this._campaignService.count(this.searchPattern, this.searchFilter).subscribe(count => this.total = count);
        let reverse = this.reverse;
        if (this.sortKey === sortKey) {
            reverse = !reverse;
        }
        this._campaignService.getCampaigns(this.page, this.perPage, sortKey, reverse, this.searchPattern, this.searchFilter)
        .subscribe(
            campaigns => {
                this.campaigns = campaigns;
                this.sortKey = sortKey;
                this.reverse = reverse;
            },
            error => this.errorMessage = <any>error
        );
    }

    destroyCampaign(id:string) {
        let result = confirm(this._translateService.instant('campaigns.delete.confirm'));
        if (result) {
            this._campaignService.destroyCampaign(id).subscribe(a => {
                    this._router.navigate(['Campaigns']);
                    this._alert_service.pushAlert({
                        type: "success",
                        msg: this._translateService.instant("campaigns.delete.success"),
                        closeable: true
                    });
                    this.getPage(1);
                },
                error => this._alert_service.pushAlert({type: "danger", msg: this._translateService.instant(error), closeable: true})
            );
        }
    }
}
